import React, {useState, useEffect} from "react";
import SalesChannelsList from "./SalesChannelsList";
import SalesChannelEditor from "./SalesChannelEditor";
import Notification from "../Common/Notification";

const SalesChannelsSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [notification, setNotification] = useState({
        show: false,
        type: "success",
        message: "",
    });
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [currentChannel, setCurrentChannel] = useState(null);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);

    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const showNotification = (type, message) => {
        setNotification({show: true, type, message});
        if (type === "success") {
            setTimeout(() => {
                setNotification((prev) => ({...prev, show: false}));
            }, 5000);
        }
    };

    const hideNotification = () => {
        setNotification((prev) => ({...prev, show: false}));
    };

    const handleAddChannel = () => {
        setCurrentChannel(null);
        setIsEditorOpen(true);
    };

    const handleEditChannel = (channel) => {
        setCurrentChannel(channel);
        setIsEditorOpen(true);
    };

    const handleCloseEditor = () => {
        setIsEditorOpen(false);
        setCurrentChannel(null);
    };

    return (
        <div>

            <SalesChannelsList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                showNotification={showNotification}
                onEditChannel={handleEditChannel}
                onAddChannel={handleAddChannel}
                selectedItems={selectedChannels}
                setSelectedItems={setSelectedChannels}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
            />

            {isEditorOpen && (
                <SalesChannelEditor
                    channel={currentChannel}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default SalesChannelsSettings;
